export enum MenuType {
  Treedis = 'treedis',
  Matterport = 'matterport',
  MatterportInstant = 'matterport-instant',
  MatterportLabel = 'matterport-label',
  MatterportFloor = 'matterport-floor',
  Popup = 'popup',
  Tab = 'tab',
  Tag = 'tag',
  Panorama = 'panorama',
  Product = 'product',
  Iframe = 'iframe',
}

export type TIframeSettings = {
  desktop: { sizeType: string; width: string; height: string };
  mobile: { sizeType: string; width: string; height: string };
};

export { TMenuObject } from './buger-menu/types';

export type TSelectOption = {
  value: string;
  label: string;
};

export type TTip = {
  src: string;
  label: string;
};

export enum IconSize {
  XL = '35px',
  LG = '25px',
  MD = '18px',
  SM = '15px',
}

export type TIconSize = IconSize.SM | IconSize.MD | IconSize.LG | IconSize.XL;

export type TWhiteLabel = {
  domainUrl: string;
  logo: string;
  primaryColor: string;
  secondaryColor: string;
  website: string;
};
